import React from 'react';
import { useReveal } from '../lib/useReveal';
const POINTS = [{
  emoji: '✨',
  text: 'aprender desde cero'
}, {
  emoji: '✨',
  text: 'crear productos modernos'
}, {
  emoji: '✨',
  text: 'mejorar tus decoraciones'
}, {
  emoji: '✨',
  text: 'vender desde casa'
}, {
  emoji: '✨',
  text: 'mostrarte profesional en redes sociales'
}];
const STRUGGLES = ['no sabés por dónde empezar,', 'tus productos no se ven profesionales,', 'o todavía no te animás a vender.'];
export function TransformationSection() {
  const [ref, isVisible] = useReveal();
  return <section className="py-12 md:py-16 px-6 bg-[#fdf2f4]" data-id="element-244">
      <div className="max-w-4xl mx-auto" data-id="element-245">
        <div className="text-center mb-8" data-id="element-246">
          <span className="inline-block text-[#e89aaa] text-xs font-bold tracking-[0.25em] uppercase mb-3" data-id="element-247">
            ♡ Sistema Completo ♡
          </span>
          <h2 className="text-2xl md:text-4xl font-serif font-bold text-[#6b4f3a] leading-tight" data-id="element-248">
            Esto no es solo <br data-id="element-249" />
            <span className="italic text-[#e89aaa]" data-id="element-250">un recetario más.</span>
          </h2>
        </div>

        <div ref={ref} className={`reveal grid md:grid-cols-2 gap-8 ${isVisible ? 'is-visible' : ''}`} data-id="element-251">
          <div className="bg-white rounded-3xl p-8 border border-[#f4b6c2]/30 shadow-[0_8px_30px_rgba(232,154,170,0.05)]" data-id="element-252">
            <h3 className="text-[#6b4f3a] font-serif font-bold text-2xl mb-6" data-id="element-253">
              Este sistema fue diseñado para ayudarte a:
            </h3>
            <ul className="space-y-3" data-id="element-254">
              {POINTS.map((p, i) => <li key={i} className="flex items-start gap-3 text-[#6b4f3a]" data-id="element-255">
                  <span className="text-[#e89aaa] mt-0.5" data-id="element-256">{p.emoji}</span>
                  <span data-id="element-257">{p.text}</span>
                </li>)}
            </ul>
          </div>

          <div className="bg-gradient-to-br from-[#fce7e9]/60 to-[#fdf2f4] rounded-3xl p-8 border border-[#f4b6c2]/30" data-id="element-258">
            <h3 className="text-[#6b4f3a] font-serif font-bold text-2xl mb-6" data-id="element-259">
              Aunque hoy sientas que:
            </h3>
            <ul className="space-y-4" data-id="element-260">
              {STRUGGLES.map((s, i) => <li key={i} className="text-[#6b4f3a] font-serif italic text-lg leading-relaxed" data-id="element-261">
                  ♡ {s}
                </li>)}
            </ul>
            <p className="mt-6 text-sm text-[#8b6f47]" data-id="element-262">
              Acá tenés todo lo que necesitás para dar el primer paso con
              confianza.
            </p>
          </div>
        </div>
      </div>
    </section>;
}